"use client";
import React, { createContext, useContext, useMemo } from 'react';
import { getSiteConfig, SiteVariant, SITE_CONFIG, SiteConfig } from './site-config';

export interface SiteContextValue extends SiteConfig {}

const SiteContext = createContext<SiteContextValue>(SITE_CONFIG.py);

interface ProviderProps {
  variant: SiteVariant;
  children: React.ReactNode;
}

export function SiteProvider({ variant, children }: ProviderProps) {
  const value = useMemo(() => getSiteConfig(variant), [variant]);
  return (
    <SiteContext.Provider value={value}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}
